module.exports = __webpack_public_path__ + "img/jinsehotLogoIntro.21a1c9d8.svg";